import { useQuery } from 'data-fetching-client';
import { GET_COMPANY_DETAILS } from 'pricing-pages-api/company-details/queries';
import { CompanySizeNumber } from 'signup-constants/signupData/CompanySizeNumber';
export const useCompanyDetails = () => {
  var _data$companyDetails;
  const {
    data,
    loading,
    error
  } = useQuery(GET_COMPANY_DETAILS);

  // Get companySize from the data
  const companySize = data === null || data === void 0 || (_data$companyDetails = data.companyDetails) === null || _data$companyDetails === void 0 ? void 0 : _data$companyDetails.companySize;

  // isVSBPortal logic
  const isVSBPortal = companySize === CompanySizeNumber.TwoToFive || companySize === CompanySizeNumber.One;
  return {
    companyDetails: data,
    loading,
    error,
    isVSBPortal
  };
};